import { createAsync } from '@solidjs/router';
import { Title } from '@solidjs/meta';
import { Show, Suspense } from 'solid-js';
import { Container, Page } from '@troon/ui';
import { NoHydration } from 'solid-js/web';
import { requireLoggedIn } from '../../providers/user';
import { TopoBg } from '../../components/topo-bg';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

export default function Account(props: RouteSectionProps) {
	const user = createAsync(() => requireLoggedIn(), { deferStream: true });

	return (
		<>
			<Title>My account | Golf with Access</Title>
			<NoHydration>
				<TopoBg placement="top" class="absolute z-0 h-48 w-screen" />
			</NoHydration>
			<Suspense>
				<Show when={user()}>
					<Page>
						<Container size="lg">{props.children}</Container>
					</Page>
				</Show>
			</Suspense>
		</>
	);
}

export const route = { preload: () => requireLoggedIn() } satisfies RouteDefinition;
